import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../../components/SEOHead';
import { usePageSEO } from '../../utils/seoUtils';
import styles from './Page404.module.sass';

const Page404 = () => {
  const seoData = usePageSEO('/404');

  return (
    <>
      <SEOHead 
        title={seoData.title}
        description={seoData.description}
        canonical={seoData.canonical}
        structuredData={seoData.structuredData}
      />
      
      <div className={styles.container}>
        <div className={styles.content}>
          {/* Illustration 404 */}
          <div className={styles.illustration}>
            <div className={styles.numberContainer}>
              <span className={styles.number}>4</span>
              <div className={styles.zeroContainer}>
                <div className={styles.zero}></div>
              </div>
              <span className={styles.number}>4</span>
            </div>
          </div>

          {/* Contenu textuel */}
          <div className={styles.textContent}>
            <h1 className={styles.title}>Page introuvable</h1>
            <p className={styles.description}>
              Désolé, la page que vous recherchez n'existe pas ou a été déplacée. 
              Vérifiez l'URL ou retournez à l'accueil pour continuer votre navigation.
            </p>
            
          </div>
        </div>
      </div>
    </>
  );
};

export default Page404;
